import React, { FC } from "react";
import { NavLink } from "react-router";
import { Box, keyframes } from "@mui/material";

import { LogoIcon } from "../../icons";

const fadeIn = keyframes`
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
`;

const LogoContent: FC = () => {
  return (
    <Box
      component={NavLink}
      to="/"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        textDecoration: "none",
        animation: `${fadeIn} 0.3s ease-in-out`,
      }}
    >
      <LogoIcon />
      <Box
        component="span"
        sx={{
          fontSize: "1.5rem",
          fontWeight: 700,
        }}
      >
        Reve
      </Box>
    </Box>
  );
};

export default LogoContent;
